import RobertShahAntony from "../assets/images/RobertShahAntony.jpeg";
import SanjayDas from "../assets/images/SanjayDas.jpeg";
import AsifBasheer from "../assets/images/AsifBasheer.jpeg";
import LijilLakshman from "../assets/images/LijilLakshman.jpg";

export const panelistsData = [
    {
        id: 1,
        name: 'Robert Shah',
        designation: 'Co-Founder and CEO, Cynapse',
        image: RobertShahAntony,
        linkedin: 'https://www.linkedin.com/in/robert-shah-antony'
    },
    {
        id: 2,
        name: 'Sanjay Das',
        designation: 'CEO & Founder, QuickPay',
        image: SanjayDas,
        linkedin: 'https://www.linkedin.com/in/sanjay-das-649954b5/'
    },
    {
        id: 3,
        name: 'Asif Basheer',
        designation: 'MD, Chillar Payment Solutions Pvt Ltd',
        image: AsifBasheer,
        linkedin: 'https://www.linkedin.com/in/asif-basheer-319159a/'
    },
    {
        id: 4,
        name: 'CA Lijil Lakshman',
        designation: 'Co-Founder and Managing Partner, LDS & Co',
        image: LijilLakshman,
        linkedin: 'https://www.linkedin.com/in/calijillakshman/'
    },
]